import { API, getToken } from "@/lib/api";

// Build an authenticated absolute URL for backend-served files/PDFs.
// Accepts either a full "/api/..." path or a bare "api/..." path.
export function authFileUrl(path) {
  if (!path) return "";
  const base = API.replace(/\/api$/, "");
  const rel = path.startsWith("/") ? path : `/${path}`;
  const token = getToken();
  const sep = rel.includes("?") ? "&" : "?";
  return `${base}${rel}${sep}auth=${encodeURIComponent(token || "")}`;
}
